import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { loginRequest, msalInstance } from './msalConfig'

// Acquires an access token for API calls, silently refreshing it via the
// cached account and falling back to a redirect if interaction is required
export async function getAccessToken (request = loginRequest) {
  const account = msalInstance.getActiveAccount()
  if (!account) {
    throw new Error('No active account: user is not signed in')
  }

  try {
    const result = await msalInstance.acquireTokenSilent({ ...request, account })
    return result.accessToken
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect(request)
      return null
    }
    throw error
  }
}
